import { autocomplete } from '@algolia/autocomplete-js'
import React, { createElement, Fragment, useEffect, useRef } from 'react'
import { render } from 'react-dom'

export function Autocomplete(props) {
    const containerRef = useRef(null)

    useEffect(() => {
        if (!containerRef.current) {
            return undefined
        }

        const search = autocomplete({
            container: containerRef.current,
            renderer: { createElement, Fragment, render },
            // onKeyDown: containerRef?.current?.setIsOpen(false),
            ...props,
        })
        return () => {
            search.setIsOpen(false)
            search.destroy()
        }
    }, [props])

    return (
        <div
            className="customSearch"
            placeholder={props.placeholder}
            value={props.value}
            ref={containerRef}
        />
    )
}
